import { get, post } from '@/utils/http-helper';
import {
  saveCourcesSectionInfo,
  saveCourcesCourseInfo,
  deleteCourcesCourseInfo,
  deleteCourcesSectionInfo,
} from '@/utils/disposer/notifications-text-helper';

const GET = '/course/view';
const CREATE_SECTION = '/course/create-section';
const UPDATE_SECTION = '/course/update-section';
const DELETE_SECTION = '/course/delete-section';
const CREATE_COURSE = '/course/create';
const UPDATE_COURSE = '/course/update';
const DELETE_COURSE = '/course/delete';

export default {
  namespaced: true,
  state: {
    courses: null,
  },
  actions: {
    async get({ commit }, eventId) {
      const agenda = await get(GET, { event_id: eventId });
      commit('updateCourses', agenda.data);
    },
    async saveSection({ commit, dispatch }, payload) {
      this._vm.$awn.async(post(payload.section_id ? UPDATE_SECTION : CREATE_SECTION, payload), response => {
        if (response.status) {
          commit('updateSection', response.data);
          this._vm.$awn.success(saveCourcesSectionInfo);
          dispatch('get', payload.event_id);
        }
      });
    },
    async deleteSection({ dispatch }, payload) {
      if (!payload.section_id) {
        dispatch('get', payload.event_id);
        return;
      }

      this._vm.$awn.async(post(DELETE_SECTION, payload), response => {
        if (response.status) {
          dispatch('get', payload.event_id);
        }
        this._vm.$awn.success(deleteCourcesSectionInfo);
      });
    },
    async saveCourse({ dispatch }, payload) {
      const fd = new FormData();

      fd.append('id', payload.id);
      fd.append('event_id', payload.event_id);
      fd.append('section_id', payload.section_id);
      fd.append('title', payload.title);
      fd.append('description', payload.description);

      if (payload.previewFile) {
        fd.append('preview', payload.previewFile);
      }

      if (payload.file) {
        fd.append('file', payload.file);
      }

      this._vm.$awn.async(post(payload.id ? UPDATE_COURSE : CREATE_COURSE, fd, true), response => {
        if (response.status) {
          this._vm.$awn.success(saveCourcesCourseInfo);

          dispatch('get', payload.event_id);
        }
      });
    },
    async deleteCourse({ dispatch }, payload) {
      if (!payload.id) {
        dispatch('get', payload.event_id);
        return;
      }

      this._vm.$awn.async(post(DELETE_COURSE, payload), response => {
        if (response.status) {
          this._vm.$awn.success(deleteCourcesCourseInfo);

          dispatch('get', payload.event_id);
        }
      });
    },
    addCourse({ commit }, course) {
      commit('addCourse', course);
    },
    addSection({ commit }, section) {
      commit('addSection', section);
    },
  },

  mutations: {
    updateCourses(state, courses) {
      state.courses = courses;
    },
    updateSection(state, section) {
      const index = state.courses.sections.findIndex(s => s.id === section.id);
      if (index !== -1) {
        state.courses.sections[index] = section;
      }
    },
    updateCourse(state, payload) {
      const courses = state.courses;
      const { data, id, section_id } = payload;

      const index = courses.courses.sections.findIndex(s => s.id === section_id);
      if (index !== -1) {
        const courseIndex = courses.courses.sections[index].courses.findIndex(c => c.id === id);
        if (courseIndex !== -1) {
          courses.sections[index].courses[courseIndex] = data;
          state.courses = JSON.parse(JSON.stringify(courses));
        } else {
          state.courses.sections[index].courses.push(data);
        }
      }
    },
    addCourse(state, course) {
      const index = state.courses.sections.findIndex(s => s.id === course.section_id);
      if (index !== -1) {
        state.courses.sections[index].courses.push(course);
      }
    },
    addSection(state, section) {
      state.courses.sections.push(section);
    },
  },
  getters: {
    get: state => state.courses,
  },
};
